import { FC } from 'react';
import { Tooltip } from 'antd';
import { convertMinsToHrsMins } from 'utils/string.utils';

import styles from './index.module.less';

type Indicator = {
  color: string;
  percentage: number;
  value: number;
};

interface ProgressBarDoubleProps {
  budget: number;
  available: Indicator;
  estimated: Indicator;
  spent: Indicator;
  direction?: 'column' | 'row';
}

const getStyleProps = (direction: 'column' | 'row') => {
  if (direction === 'column') {
    return {
      containerStyle: { height: '100%', width: '24px' },
      flexDirection: 'column',
      tooltipPlacement: 'left',
      roundedEdgeClass: styles.roundedTop,
      sizeKey: 'height',
      roundedClass: styles.roundedTop,
    };
  }

  return {
    containerStyle: { width: '100%', height: '10px' },
    flexDirection: 'row',
    tooltipPlacement: 'topLeft',
    roundedEdgeClass: styles.roundedRight,
    sizeKey: 'width',
    roundedClass: styles.roundedRight,
  };
};

const ProgressBarLite: FC<ProgressBarDoubleProps> = ({ budget, available, estimated, spent, direction = 'row' }) => {
  const isColumn = direction === 'column';

  const { containerStyle, flexDirection, tooltipPlacement, roundedClass } = getStyleProps(direction);

  let segments = [
    { ...spent, label: 'Spent' },
    { ...estimated, label: 'Estimate' },
    { ...available, label: 'Available' },
  ];

  if (isColumn) {
    segments = [...segments].reverse();
  }

  return (
    <div style={containerStyle}>
      <div className={styles.progressBar} style={{ flexDirection: flexDirection as any }}>
        {segments.map((segment, index) => {
          const size = segment.percentage;

          const tooltipTitle = (
            <div>
              <span>{segment.label}:</span> {convertMinsToHrsMins(segment.value)} h <br />
            </div>
          );

          return (
            <Tooltip title={tooltipTitle} key={index} placement={tooltipPlacement as 'left' | 'topLeft'} className={roundedClass}>
              <div
                className={styles.segment}
                style={{
                  ...(isColumn ? { height: `${size}%` } : { width: `${size}%` }),
                  backgroundColor: segment.color,
                }}
              />
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBarLite;
